module.exports = __webpack_public_path__ + "img/cover-redeem-bg.40545491.png";